import { render, staticRenderFns } from "./ViewStatsModal.vue?vue&type=template&id=04d2182c&scoped=true"
import script from "./ViewStatsModal.vue?vue&type=script&lang=js"
export * from "./ViewStatsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2182c",
  null
  
)

export default component.exports